<template>
  <transition name="fade">
    <popup msg-popup v-if="command">
      <div class="panel">
        <div class="ttl">
          <a class="close" @click="reject" v-if="command.isConfirm"></a>
          <a class="close" @click="resolve" v-else></a>
        </div>
        <div class="ph-50 pb-50 tc">
          <p class="title" v-if="command.title">
            <span v-html="command.title"></span>
          </p>
          <p class="msg pt-30 fs-16" v-if="command.msg" v-html="command.msg">
          </p>
          <div class="page-bts pt-50">
            <a class="ok btn lg red" @click="resolve">확인</a>
            <a class="ok btn lg" v-if="command.isConfirm" @click="reject">취소</a>
          </div>
        </div>
      </div>
    </popup>
  </transition>
</template>

<script>
import Popup from './Popup.vue';

export default {
  name: 'SimpleMsgPopup',
  components: { Popup },
  computed: {
    command() {
      return this.$store.state.simpleMsg;
    },
  },
  methods: {
    resolve() {
      const { command } = this;
      this.$store.commit('simpleMsg', null);
      command.resolve();
    },
    reject() {
      // const { command } = this;
      this.$store.commit('simpleMsg', null);
      // command.reject();
    },
    keydown(e) {
      if (!this.command) return;
      if (e.keyCode === 13) this.resolve();
      if (e.keyCode === 27) this.reject();
    },
  },
  data() {
    return {
      show: false,
    };
  },
  mounted() {
    window.addEventListener('keydown', this.keydown);
  },
};
</script>

<style lang="less" scoped>
  @import "../../less/proj";
  [msg-popup]{
    .panel{
      //.hidden;
      left:50%;.ml(-250);.t(200);.abs;.w(500px;);background:#FFFFFF;
      .ttl { .h(80); .fs(24); .lh(80); color:#fff; .tc; .bold; background:#FFFFFF;
        .close { .abs; .rt(20,26); .wh(28); .contain('@{common}/pop-close-b.png'); }
      }
      .bar{.h(78px);.tc;.bgc(@c-title-g3);.lh(78px);
        .title{ font-weight: 700;font-size: 24px; color:white;.ib;.pl(20px);.lh(76px);}
        .bt_x{
          .ib;.fs(30px,70px);color:white;.pr(20px);.fr;
        }
      }
      .title{.tc; span{.fs(21); .-b(@c-status-change,2px); .tc; .ib;}}
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/components/SimpleMsgPopup.vue